import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Radio, { RadioProps } from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import nexticon from './images/button-arrow1.jpg';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import confirmimg from './images/vector.jpg';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import innerAthalogo from './images/logo-bg.png';
export default class Summary extends Component {
	constructor(props) {
    super(props);
	 this.state = {pagename:'',isconfirm:1,redirect:false,scheduleData:[],oramt:0,sumdata:[],paymentkey:'',orname:'',oradrs:'',oremail:'',orphone:'',Orid:'',orsession:'',isoffer:"0",couponcode:"",btndisabled:false,btnofferdisabled:false,btntext:'Continue Payment',btnoffertext:'Apply Offer'}
	 
	}
	handleErrorclose=(event)=>{
	  
	this.setState({erroropen: false});  
  }
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
	componentDidMount() { 
	
	 let search = window.location.href;
	 let Orid = this.getParameterByName('orid',search);
	if(Orid!==null)
 {
		this.ApigetOrderbyid(Orid);
	}
	
	
	}
	 onChangeOffer= (event: React.ChangeEvent<HTMLInputElement>) => {
	  this.setState({isoffer: event.target.value}); 
  }
	myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

openCheckout=(event)=>{
	let self=this;
	var formData1 = new FormData();
	formData1.append('action','paylist')
	formData1.append('or_sesssion',this.state.orsession)
	formData1.append('or_id',this.state.Orid)
	formData1.append('amount',this.state.oramt)
	 axios.post(Serverurl+"ajaxorderpayment.php", formData1, {
				})
				.then(res => {
					let strorderid=res.data.trim();
					

	

    let options = {
      "key": "rzp_live_tXtvDMASGgYmxA",
      "amount": Number(self.state.oramt*100), // 2000 paise = INR 20, amount in paisa
      "name": "Atha Yog",
      "description": "Atha Yog",
      "image": Serverurl+"/AY-192.png",
	  "order_id": strorderid, 
      "handler": function (response){
        
	self.paymentSuccess(response.razorpay_payment_id);	
		
		
      },
      "prefill": {
        "name": this.state.orname,
        "email": this.state.oremail,
		"contact":this.state.orphone
      },
      "notes": {
        "address": ""
      },
      "theme": {
        "color": "#73825b"
      }
    };
    
    let rzp = new window.Razorpay(options);
    rzp.open();
	});	  
  }
  paymentSuccess= (val) => {
	  let responsecode = val;
	  
	   var formData = new FormData();
	
	formData.append('action','Paymentstatus')
	formData.append('op_trackinginfo',responsecode)
	formData.append('or_id',this.state.Orid)
	formData.append('or_totalamount',this.state.oramt)
		formData.append('or_sesssion',this.state.orsession)
	
	  axios.post(Serverurl+"ajaxorders.php", formData, {
				}).then(res => {
	  this.setState({isconfirm:2,	});
localStorage.removeItem("AYorderid")
			localStorage.removeItem("AYSession")
			let cnt=Number(localStorage.getItem("AYorcount"))+1;
			localStorage.setItem("AYorcount",cnt);

				});	  
  }
	ApigetOrderbyid(Orid){
	axios.post(Serverurl+'ajaxorders.php?action=list&or_id='+Orid)
  .then(resp => {  
		
    if(resp.data.length>0){
			this.setState({  
			sumdata:resp.data,
			orname:resp.data[0].or_name,Orid:resp.data[0].or_id,
oremail:resp.data[0].or_email,orsession:resp.data[0].or_sesssion,
orphone:resp.data[0].or_phone,oramt:resp.data[0].total
			});
			 if(resp.data[0]["or_booktype"]==="1")
			{
		this.Apigetcustomerslotbyid(Orid);
			}
		
     }
  
    });
	
} 

Apigetcustomerslotbyid(orid){
		
	axios.post(Serverurl+'ajaxcustomerschedule.php?action=getall&cs_or_id='+orid)
  .then(resp => {  
		
    if(resp.data.length>0){
			this.setState({  
			scheduleData:resp.data,

			});
			
		
     }
  
    });
	
   }


	
	handleErrorclose=(event)=>{
	  
	this.setState({errorpen: false});  
  }
	
	
	 render(){
		
	 	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	 return(
	 
	 	  <div className="signin-bg">
<div className="formbox"><div className="regform">
 <div className="aligncentr">
   <img src={innerAthalogo} alt="Atha Yoga" width="200px"/>
   </div>
<div className="formpadd">
{this.state.isconfirm===2 && (<React.Fragment>
 <div className="confimimg">
<img src={confirmimg} />
</div>
<h2 className="aligncentr">Thank you, Your payment is successful</h2>
</React.Fragment>
)}
{this.state.isconfirm===1 && (
<h2>Here is a summary of the subscription details, please confirm to proceed with the payment</h2>
)}
<ul className="summarydiv">

 {this.state.sumdata.map((item,index) => {  
			
           return ( <React.Fragment>
<li>
<p><b>Preference</b> : {item.classtype}</p></li>
<li>
<p><b>Duration</b> : {item.sb_title}</p></li>
{(item.sm_slotname!=null && item.sm_slotname!="") && ( 
<li>
<p><b>Slot</b> : {item.sm_slotname}</p></li>
)}
{item.or_booktype==="1" && (
<li>
<p><b>Start Date</b> : {item.classstartdate}

 &nbsp;<b>End Date</b> : {item.or_enddate}
</p></li>)}


<li><p><b>Price</b> : Rs.{item.or_totalamount}/-</p></li>
	{item.or_discount!=="0" && (
<li><p><b>Discount</b> : Rs.{item.or_discount}/-</p></li>
	)}
	{item.total!==0 && (
<li><p><b>Total</b> : Rs.{item.total}/-</p></li>
	)}
	{(item.or_classtype==="1" ) && (
<li><p><b>Location</b> : {item.or_address} </p></li>
	)}
	{(item.or_classtype==="3" || item.or_classtype==="4" || item.or_classtype==="2") && (
<li><p><b>Location</b> : {item.bm_name} <br/>{item.bm_address}</p></li>
	)}
<li><p><b>Billing Address </b>: {item.or_billingaddress}</p></li>
 </React.Fragment> )})}
 </ul>
  <div className="clear"></div>
  {this.state.scheduleData.length>0 && ( <React.Fragment>
  
   <Accordion className="summarydiv">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <h4 >Slots and Dates </h4>
        </AccordionSummary>
        <AccordionDetails>
         
       
  
 <ul >

 {this.state.scheduleData.map((erows,index) => {  
			var l=Number(index+1);
           return ( <React.Fragment>
<li>
 <p>{l}. {erows.sm_slotname} : {erows.date} {erows.st_name !="" && (<React.Fragment>- {erows.st_name}</React.Fragment>)}</p></li>
<div className="clear"></div>
 </React.Fragment> )})}
  </ul> 
   </AccordionDetails>
      </Accordion>
  </React.Fragment>
 )}
 <div className="clear"></div>
 
 {this.state.isconfirm===1 && (<React.Fragment>

	 <br/>
	<p className="aligncentr"><Button
            type="submit"
            halfWidth
			disabled={this.state.btndisabled}
            variant="contained"   
           className="primarybtncolr"
           id="btnLogin" 
		onClick={this.openCheckout}
           
          >
           {this.state.btntext} 
          </Button>
		  </p>
	</React.Fragment>
 )}
</div> <div className="footerbg">
	   <p>© Copyright {(new Date().getFullYear())} AthaYog Living, All Rights Reserved</p>
	   </div>
</div></div>
	 </div>
	 );
	 
	 }
}




